// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import DOMPurify from "dompurify";
import style from "./PermissonSetting.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import useLanguageChange from "../../../hooks/useLanguageChange";

export const PermissionSetting = (props) => {
  const { t } = useLanguageChange(props.locale);
  const [isSettingShow, setSettingShow] = useState(false);
  const [isPermissionListShow, setPermissonListShow] = useState(false);
  const [isSelectUserShow, setSelectUserShow] = useState(false);
  const [isInvitePermissonShow, setInvitePermissonShow] = useState(false);
  const [selectUserList, setSelectUserList] = useState([]);
  const [listLength, setListLength] = useState(false);
  const [permisson, setPermisson] = useState(null);
  const [inputFocus, setFocus] = useState(false);
  const [compositionFlag, setCompositionFlag] = useState(false);
  const [userList, setUserList] = useState([]);
  const [permissionIndex, setPermissionIndex] = useState(null);
  const [typeIndex, setTypeIndex] = useState(null);
  const [permissionGroups, setPermissionGroups] = useState([]);
  const [errMessage, setErrMessage] = useState(null);
  const [inputErrMessage, setInputErrMessage] = useState(null);
  const [validateErrMessage, setValidateErrMessage] = useState(null);
  const [validMessage, setValidMessage] = useState("");
  const [changeMessage, setChangeMessage] = useState("");
  const settingRef = useRef(null);
  const permissionListRef = useRef(null);
  const selectUserRef = useRef(null);
  const invitePermissonRef = useRef(null);
  const inputRef = useRef(null);
  const inviteTextRef = useRef(null);

  const instance = axios.create({
    baseURL: `${window.origin}/${props.client}`,
  });

  const getGroups = async () => {
    await instance
      .get("/resource_permission_groups", {
        params: {
          resourceable_type: props.resourceableType,
          resourceable_id: props.resourceableId,
        },
      })
      .then((res) => {
        setPermissionGroups(res.data.resource_permission_groups);
      });
  };

  const getArraysDiff = (array1, array2) => {
    const array1NameArray = array1.map((itm) => {
      return itm.name;
    });
    const array2NameArray = array2.map((itm) => {
      return itm.name;
    });

    const arr1 = [...new Set(array1NameArray)];
    const arr2 = [...new Set(array2NameArray)];
    return [...arr1, ...arr2].filter((val) => {
      return !arr1.includes(val) || !arr2.includes(val);
    });
  };

  const getUserList = async (val = null) => {
    await instance
      .get("/resource_permission_groups/permission_groups", {
        params: {
          query: val,
          resourceable_type: props.resourceableType,
          resourceable_id: props.resourceableId,
        },
      })
      .then((res) => {
        if (selectUserList.length === 0) {
          setUserList(res.data.permission_groups);
        } else {
          const diff = getArraysDiff(res.data.permission_groups, selectUserList);
          const userDiff = res.data.permission_groups.filter((item) => {
            return diff.includes(item.name);
          });
          setUserList(userDiff);
        }
      });
  };
  const updateRole = async (role, resourcePermissionGroup) => {
    const f = window.confirm(t("PermissionSetting.権限を変更します。実行してもいいですか？"));
    if (f) {
      await instance
        .patch(`/resource_permission_groups/${resourcePermissionGroup.id}/update_role`, {
          resource_permission_group: {
            role: role,
          },
        })
        .then(() => {
          getGroups();
          setChangeMessage(t("PermissionSetting.権限が変更されました"));
          setPermissonListShow(false);
        })
        .catch(({ response }) => {
          setValidMessage(response.data.role[0]);
        });
    }
  };

  const inviteUser = async (member, guest) => {
    const params = {
      resource_permission_groups: member,
      guest_resource_permission_groups: guest,
      message: inviteTextRef.current.value === "" ? inviteTextRef.current.placeholder : inviteTextRef.current.value,
    };
    await instance
      .post(
        props.resourceableType === "DynamicDatabase"
          ? `dynamic_databases/${props.databaseId}/create_authority`
          : `/resource_permission_groups/batch_create`,
        params,
      )
      .then(() => {
        getGroups();
        setSelectUserList([]);
        setChangeMessage(
          props.resourceableType === "DynamicDatabase"
            ? t("PermissionSetting.データベースに新たにメンバーを追加しました")
            : t("PermissionSetting.権限が変更されプロジェクトに新たにメンバーを追加しましたました"),
        );
        setFocus(false);
      })
      .catch(({ response }) => {
        setErrMessage(response.data.message);
      });
  };

  const preInviteUser = async () => {
    if (!selectUserList.length) return;
    const f = window.confirm(
      props.resourceableType === "DynamicDatabase"
        ? t("PermissionSetting.新しいメンバーをこのデータベースに招待します。実行しますか？")
        : t("PermissionSetting.新しいメンバーをこのプロジェクトに招待します。実行しますか？"),
    );
    if (f) {
      const paramMember = [];
      const paramGuest = [];
      const createGuestList = [];

      selectUserList.forEach((user) => {
        if (user.is_guest) {
          createGuestList.push(user.email);
        } else {
          paramMember.push({
            permission_group_id: user.id,
            resourceable_type: props.resourceableType,
            resourceable_id: props.resourceableId,
            role: permisson,
          });
        }
      });

      if (createGuestList.length && props.inviteGuests) {
        const submitGuest = {
          dynamic_database_id: props.resourceableId,
          email_list: createGuestList,
        };
        await instance
          .post(`/members/create_guests`, submitGuest)
          .then((response) => {
            response.data.permission_group_ids.forEach((id) => {
              paramGuest.push({
                permission_group_id: id,
                resourceable_type: props.resourceableType,
                resourceable_id: props.resourceableId,
                role: permisson,
              });
            });
            inviteUser(paramMember, paramGuest);
          })
          .catch(({ response }) => {
            setInputErrMessage(response.data.message);
          });
      } else {
        inviteUser(paramMember, paramGuest);
      }
    }
  };

  const deleteRole = async (resourcePermissionGroup) => {
    const f = window.confirm(t("PermissionSetting.権限を変更します。実行してもいいですか？"));
    if (f) {
      await instance
        .delete(`/resource_permission_groups/${resourcePermissionGroup.id}`)
        .then(() => {
          getGroups();
          setChangeMessage(t("PermissionSetting.権限削除しました"));
        })
        .catch(({ response }) => {
          setValidMessage(response.data.base[0]);
        });
    }
  };

  const memberPresence = async (inputValue, isInput) => {
    setInputErrMessage(null);
    if (inputValue === "") return;
    if (selectUserList.length >= 40) {
      setInputErrMessage(t("PermissionSetting.一度に招待できるのは40名までです"));
      return;
    }
    const existUsers = permissionGroups.single_member;
    let inviteJudge = false;
    let inputClear = false;
    if (selectUserList.length) {
      for (let index = 0; index < selectUserList.length; index++) {
        const user = selectUserList[index];
        if (user.name === inputValue || user.email === inputValue) {
          inviteJudge = true;
          setInputErrMessage(user.name + t("PermissionSetting.さんはすでに選択されています"));
          break;
        }
      }
    }
    if (userList.length && !inviteJudge) {
      const unSelectedUser = [];
      userList.forEach((user) => {
        if (user.name === inputValue || user.email === inputValue) {
          inviteJudge = true;
          inputClear = true;
          setSelectUserList([...selectUserList, { name: user.name, id: user.id, email: user.email, is_guest: false }]);
        } else {
          unSelectedUser.push(user);
        }
      });
      if (inviteJudge) {
        setUserList(unSelectedUser);
      }
    }
    if (isInput) {
      if (existUsers.length && !inviteJudge) {
        for (let index = 0; index < existUsers.length; index++) {
          const user = existUsers[index];
          if (user.name === inputValue || user.description === inputValue) {
            inviteJudge = true;
            setInputErrMessage(
              user.name +
                t("PermissionSetting.さんはすでに「") +
                props.sectionName +
                t("PermissionSetting.」の権限が付与されています"),
            );
            break;
          }
        }
      }
      if (!inviteJudge) {
        const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
        if (props.inviteGuests) {
          if (isEmail.test(inputValue)) {
            await instance
              .post(`/client_members/validate_guest`, { email: inputValue })
              .then(() => {
                inviteJudge = true;
                inputClear = true;
                setSelectUserList([
                  ...selectUserList,
                  { name: inputValue, id: null, email: inputValue, is_guest: true },
                ]);
              })
              .catch(({ response }) => {
                setValidateErrMessage(response.data.message);
              });
          } else {
            setInputErrMessage(
              t("PermissionSetting.メンバーアカウントを選択するかメールアドレスを正しく入力してください"),
            );
          }
        } else {
          setInputErrMessage(t("PermissionSetting.メンバーアカウントを選択してください"));
        }
      }
    }
    if (inputClear) {
      inputRef.current.value = "";
    }
  };

  const arrowAction = (action, i, e) => {
    if (action === "ArrowUp" && document.getElementById(`userlist-${i + -1}`)) {
      document.getElementById(`userlist-${i + -1}`).focus();
      e.preventDefault();
    }
    if (action === "ArrowDown" && document.getElementById(`userlist-${i + 1}`)) {
      document.getElementById(`userlist-${i + 1}`).focus();
      e.preventDefault();
    }
  };
  useEffect(() => {
    getUserList();
    setPermissionGroups(props.resourcePermissionGroups);
    setPermisson("admin");
  }, []);

  useEffect(() => {
    if (!settingRef?.current) return;
    const hundleClickOutside = (e) => {
      if (settingRef.current !== null && !settingRef.current.contains(e.target)) {
        setSettingShow(false);
        setPermissonListShow(false);
        setSelectUserShow(false);
      }
    };
    document.addEventListener("mouseup", hundleClickOutside);
  }, [settingRef?.current]);
  useEffect(() => {
    if (!permissionListRef?.current) return;
    const hundleClickOutside = (e) => {
      if (permissionListRef.current !== null && !permissionListRef.current.contains(e.target)) {
        setPermissonListShow(false);
      }
    };
    document.addEventListener("mouseup", hundleClickOutside);
  }, [permissionListRef?.current]);
  useEffect(() => {
    if (!selectUserRef?.current) return;
    const hundleClickOutside = (e) => {
      if (selectUserRef.current !== null && !selectUserRef.current.contains(e.target)) {
        setSelectUserShow(false);
        setInputErrMessage(null);
      }
    };
    document.addEventListener("mouseup", hundleClickOutside);
  }, [isSelectUserShow, selectUserRef?.current]);
  useEffect(() => {
    if (!invitePermissonRef?.current) return;
    const hundleClickOutside = (e) => {
      if (invitePermissonRef.current !== null && !invitePermissonRef.current.contains(e.target)) {
        setInvitePermissonShow(false);
      }
    };
    document.addEventListener("mouseup", hundleClickOutside);
  }, [isInvitePermissonShow, invitePermissonRef?.current]);
  useEffect(() => {
    if (selectUserList.length === 0) {
      setListLength(false);
    } else {
      setListLength(true);
    }
    getUserList();
  }, [selectUserList]);

  useEffect(() => {
    if (validMessage !== "") {
      setTimeout(() => {
        setValidMessage("");
      }, 7000);
    }
  }, [validMessage]);
  useEffect(() => {
    if (changeMessage !== "") {
      setTimeout(() => {
        setChangeMessage("");
      }, 7000);
    }
  }, [changeMessage]);
  useEffect(() => {
    setInvitePermissonShow(false);
  }, [permisson]);

  return (
    <div className="position-relative">
      <div
        className={style.permissonBtn}
        onClick={() => {
          setSettingShow((prevState) => !prevState);
        }}
      >
        <img src={getImageUrl("images/icons/add_people.svg")} />
        <div className={style.shareBtn}>{t("PermissionSetting.共有")}</div>
      </div>
      {validMessage && (
        <div className="flash_message alert" style={{ zIndex: 9999 }}>
          {validMessage}
        </div>
      )}
      {changeMessage && (
        <div className="flash_message notice" style={{ zIndex: 9999 }}>
          {changeMessage}
        </div>
      )}
      {isSettingShow && (
        <div ref={settingRef} className={style.permissonContainer}>
          {props.resourceableType === "DynamicDatabase" &&
          props.resourcePermissionGroups.single_member.length === 0 &&
          !props.isEditable ? (
            <div className="p-2">
              {props.databaseName}
              {(t("PermissionSetting.に権限が設定されていません。"), { dataBaseName: props.databaseName })}
              <div>{t("PermissionSetting.権限が設定できるのは、編集権限を持ったメンバーのみです。")}</div>
            </div>
          ) : (
            <>
              {props.isEditable && !props.isGuest && (
                <div
                  className={`${errMessage && errMessage?.permission_group_id ? `${style.errorInput}` : ""} ${
                    style.userListContainer
                  }`}
                >
                  <div
                    className={style.userListArea}
                    onClick={(e) => {
                      if (e.target?.lastChild && typeof e.target.lastChild.focus === "function") {
                        e.target.lastChild?.focus();
                      }
                      setSelectUserShow(true);
                      setFocus(true);
                    }}
                  >
                    {selectUserList.map((user, i) => (
                      <div className={style.userLabel} key={i}>
                        <div
                          style={{
                            paddingRight: "8px",
                            overflowWrap: "anywhere",
                          }}
                        >
                          <span style={{ maxWidth: user.is_guest ? "240px" : "auto" }}>{user.name}</span>
                          {user.is_guest && <>{t("PermissionSetting.(ゲスト)")}</>}
                        </div>
                        <img
                          src={getImageUrl("images/icons/cancel_gray.svg")}
                          width={14}
                          height={14}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const f = selectUserList.filter((elm) => {
                              return elm !== user;
                            });
                            setSelectUserList(f);
                            getUserList();
                            setErrMessage(null);
                          }}
                        />
                      </div>
                    ))}
                    <input
                      ref={inputRef}
                      className={style.inputLabel}
                      placeholder={!listLength && t("PermissionSetting.メールかユーザーを追加")}
                      onClick={() => {
                        setSelectUserShow(true);
                        setInputErrMessage(null);
                        setValidateErrMessage(null);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !compositionFlag) {
                          memberPresence(e.target.value, true);
                        }
                        arrowAction(e.key, -1, e);
                      }}
                      onCompositionStart={() => {
                        setCompositionFlag(true);
                      }}
                      onCompositionEnd={() => {
                        setCompositionFlag(false);
                      }}
                      onChange={(e) => {
                        getUserList(e.target.value);
                        setInputErrMessage(null);
                        setValidateErrMessage(null);
                      }}
                    />
                  </div>
                  {inputFocus && (
                    <div
                      className={style.parmissonLabel}
                      onClick={() => {
                        setInvitePermissonShow(true);
                      }}
                    >
                      {permisson === "admin"
                        ? t("PermissionSetting.編集権限")
                        : permisson === "reader"
                        ? t("PermissionSetting.閲覧権限")
                        : t("PermissionSetting.権限なし")}
                      <img src={getImageUrl("images/icons/chevron_right.svg")} />
                      {isInvitePermissonShow && (
                        <div ref={invitePermissonRef} className={style.permissonListContainer}>
                          {Object.keys(props.roleDescriptions).map((role) => (
                            <>
                              <div className={style.permissonSelectArea}>
                                <div
                                  style={{ flexFlow: "column", padding: "12px", width: "100%" }}
                                  onClick={() => {
                                    setPermisson(role);
                                  }}
                                >
                                  <div className={style.permissonName}>
                                    {props.roleDescriptions[role]["display_name"]}
                                  </div>
                                  <div style={{ fontSize: "12px" }}>{props.roleDescriptions[role]["description"]}</div>
                                </div>
                                {permisson === role && <img src={getImageUrl("images/icons/check.svg")} />}
                              </div>
                            </>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {(inputErrMessage || errMessage || validateErrMessage) && (
                <div className={style.errMessage}>
                  {inputErrMessage && <span>{inputErrMessage}</span>}
                  {errMessage &&
                    errMessage.map((message, index) => (
                      <span
                        style={{ display: "block" }}
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(message, { ALLOWED_TAGS: ["a"], ALLOWED_ATTR: ["href"] }),
                        }}
                      ></span>
                    ))}
                  {validateErrMessage && (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(validateErrMessage, { ALLOWED_TAGS: ["a"], ALLOWED_ATTR: ["href"] }),
                      }}
                    ></span>
                  )}
                </div>
              )}
              {inputFocus ? (
                <>
                  <div style={{ marginTop: "8px", position: "relative", margin: "14px 0px" }}>
                    {isSelectUserShow && (
                      <div ref={selectUserRef} className={style.selectContainer}>
                        <div style={{ color: "#777777", marginBottom: "8px" }}>
                          {t("PermissionSetting.人を選択する")}
                        </div>
                        <div style={{ overflow: "auto", height: "172px" }}>
                          {userList.map((user, i) => {
                            return (
                              <div
                                id={`userlist-${i}`}
                                key={i}
                                className={style.selectLabel}
                                onClick={() => {
                                  memberPresence(user.name, false);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    memberPresence(e.target.innerText, false);
                                  }
                                  arrowAction(e.key, i, e);
                                }}
                                tabIndex={0}
                              >
                                {user.name}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                    <textarea
                      ref={inviteTextRef}
                      className={style.messageArea}
                      placeholder={t("PermissionSetting.placeholder_message", {
                        accountName: props.accountName,
                        context: props.inviteGuests
                          ? t("PermissionSetting.データベース")
                          : t("PermissionSetting.プロジェクト"),
                        sectionName: props.sectionName,
                      })}
                    />
                  </div>

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <button
                      className="btn"
                      style={{
                        width: "235px",
                        boxShadow: "4px 4px 20px rgba(0, 0, 0, 0.08)",
                      }}
                      onClick={() => {
                        setFocus(false);
                        setSelectUserList([]);
                      }}
                    >
                      {t("PermissionSetting.キャンセル")}
                    </button>
                    <button
                      className="btn btn-info"
                      style={{
                        width: "235px",
                        boxShadow: "4px 4px 20px rgba(0, 0, 0, 0.08)",
                        color: "white",
                      }}
                      onClick={() => {
                        preInviteUser();
                      }}
                    >
                      {t("PermissionSetting.招待")}
                    </button>
                  </div>
                </>
              ) : (
                <div>
                  {Object.keys(permissionGroups).map((groupType, index) => (
                    <div key={index}>
                      {permissionGroups[groupType].map((resourcePermissionGroup, i) => (
                        <div key={i} style={{ padding: "7px 0px" }}>
                          <div className={style.parmissonEditContainer}>
                            <div style={{ flexFlow: "column" }}>
                              <div
                                style={{
                                  fontSize: "14px",
                                  wordBreak: "break-all",
                                  maxWidth: "300px",
                                }}
                              >
                                {resourcePermissionGroup.name}
                                {resourcePermissionGroup.is_guest && (
                                  <span
                                    style={{
                                      fontSize: "0.9em",
                                      paddingLeft: "5px",
                                    }}
                                  >
                                    {t("PermissionSetting.(ゲスト)")}
                                  </span>
                                )}
                              </div>
                              <div
                                style={{
                                  color: "#777777",
                                  fontSize: "12px",
                                  wordBreak: "break-all",
                                  maxWidth: "300px",
                                }}
                              >
                                {resourcePermissionGroup.description}
                              </div>
                            </div>
                            <div
                              className={style.parmissonLabel}
                              onClick={() => {
                                if (props.isEditable && !props.isGuest) {
                                  setPermissonListShow(true);
                                  setPermissionIndex(index);
                                  setTypeIndex(i);
                                }
                              }}
                              style={{ paddingRight: resourcePermissionGroup.is_current_member && "28px" }}
                            >
                              {props.roleDescriptions[permissionGroups[groupType][i].role].display_name}
                              {props.isEditable && !props.isGuest && !resourcePermissionGroup.is_current_member && (
                                <img src={getImageUrl("images/icons/chevron_right.svg")} />
                              )}
                              {isPermissionListShow &&
                                permissionIndex === index &&
                                typeIndex === i &&
                                props.isEditable &&
                                !props.isGuest &&
                                !resourcePermissionGroup.is_current_member && (
                                  <div ref={permissionListRef} className={style.permissonListContainer}>
                                    {Object.keys(props.roleDescriptions).map((role) => (
                                      <>
                                        <div
                                          className={style.permissonSelectArea}
                                          onClick={() => {
                                            updateRole(role, resourcePermissionGroup);
                                          }}
                                        >
                                          <div
                                            style={{
                                              flexFlow: "column",
                                              padding: "12px",
                                            }}
                                          >
                                            <div className={style.permissonName}>
                                              {props.roleDescriptions[role]["display_name"]}
                                            </div>
                                            <div style={{ fontSize: "12px" }}>
                                              {props.roleDescriptions[role]["description"]}
                                            </div>
                                          </div>
                                          {props.roleDescriptions[permissionGroups[groupType][i].role][
                                            "display_name"
                                          ] === props.roleDescriptions[role]["display_name"] && (
                                            <img src={getImageUrl("images/icons/check.svg")} />
                                          )}
                                        </div>
                                      </>
                                    ))}
                                    {groupType !== "all_members" && !resourcePermissionGroup.is_guest && (
                                      <div
                                        className={style.permissonSelectArea}
                                        onClick={() => {
                                          deleteRole(resourcePermissionGroup);
                                        }}
                                      >
                                        <div
                                          style={{
                                            flexFlow: "column",
                                            padding: "12px",
                                          }}
                                        >
                                          <div className={style.permissonNameRed}>
                                            {groupType === "all_members"
                                              ? t("PermissionSetting.権限なし")
                                              : props.resourceableType === "DynamicDatabase"
                                              ? t("PermissionSetting.個別の権限を削除")
                                              : t("PermissionSetting.削除")}
                                          </div>
                                          {props.resourceableType === "DynamicDatabase" && (
                                            <div style={{ fontSize: "12px" }}>
                                              {t(
                                                "PermissionSetting.データベース個別の権限設定を削除し、プロジェクト権限に従います",
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

PermissionSetting.propTypes = {
  locale: PropTypes.string,
  client: PropTypes.string,
  resourceableId: PropTypes.string,
  resourceableType: PropTypes.string,
  roleDescriptions: PropTypes.object,
  resourcePermissionGroups: PropTypes.object,
  accountName: PropTypes.string,
  sectionName: PropTypes.string,
  inviteGuests: PropTypes.bool,
  isEditable: PropTypes.bool,
  isGuest: PropTypes.bool,
  databaseId: PropTypes.string,
  is_current_member: PropTypes.bool,
  databaseName: PropTypes.string,
};
